import { useEffect } from "react";

import { getPrefill, getTrailBySession } from "../useLearning";
import { ACTION } from "./editorModel";
import { sessionFromPrefill } from "./editorPrefill";

/** The engineer's own stated cause from the stored case record, only when it has no root cause: else "". */
export function statedCauseOf(payload) {
  const trail = (payload && payload.trail) || {};
  if (String(trail.root_cause || "").trim()) return "";
  return String(trail.stated_root_cause || "").trim();
}

/**
 * Fetches the server's prefill for this chat once, after the editor has already opened on the local fallback, and hands it to the
 * model (which replaces an untouched form and merges into a touched one). Any failure (not in a diagnosis, 503, offline) is
 * silent: the editor keeps what it has. Never gates the eligibility check or the save.
 *
 * Alongside it, the stored case record: when it holds no root cause but the engineer stated one in the chat, that statement is
 * offered as the root cause instead of the engine's leading guess (the model keeps it whichever arrives first). Same silence.
 */
export default function usePrefill({ sessionId, dispatch }) {
  useEffect(() => {
    if (!sessionId) return undefined;
    const controller = new AbortController();
    getPrefill(sessionId, { signal: controller.signal })
      .then((data) => {
        const session = sessionFromPrefill(data);
        if (session && !controller.signal.aborted) dispatch({ type: ACTION.APPLY_PREFILL, session });
      })
      .catch(() => {});
    Promise.resolve()
      .then(() => getTrailBySession(sessionId))
      .then((payload) => {
        const stated = statedCauseOf(payload);
        if (stated && !controller.signal.aborted) dispatch({ type: ACTION.APPLY_STATED_CAUSE, value: stated });
      })
      .catch(() => {});
    return () => controller.abort();
  }, [sessionId, dispatch]);
}
